<template>

  <div class="articlemanagement">
    <Tabs
      v-model="dataType"
      @on-click="modelShow"
    >
      <Tab-pane
        :label="langMap.versionData[lang]"
        name="1"
      ></Tab-pane>
      <Tab-pane
        :label="langMap.statusData[lang]"
        name="2"
      ></Tab-pane>
      <Tab-pane
        :label="langMap.movementData[lang]"
        name="3"
      ></Tab-pane>
      <!-- <Tab-pane
        :label="langMap.warningData[lang]"
        name="4"
      ></Tab-pane> -->
    </Tabs>
    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col
            :xs="24"
            :sm="24"
            :md="10"
            :lg="10"
          >
          <Divider
            v-if="dataType === '1'"
            orientation="left"
          >{{langMap.versionHistoryData[lang]}}</Divider>
          <Divider
            v-if="dataType === '2'"
            orientation="left"
          >{{langMap.statusHistoryData[lang]}}</Divider>
          <Divider
            v-if="dataType === '3'"
            orientation="left"
          >{{langMap.movementHistoryData[lang]}}</Divider>
          <Divider
            v-if="dataType === '4'"
            orientation="left"
          >{{langMap.warningHistoryData[lang]}}</Divider>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="14"
            :lg="14"
          >
          <Form :label-width="80">
            <div class="des-cardTittle-box">
              <FormItem
                :label="langMap.robot[lang]"
                class="leftFlex"
              >
                <Select v-model="robotId">
                  <Option
                    :key="item.id"
                    :value="item.id"
                    v-for="item in robotList"
                  >{{item.name}}</Option>
                </Select>
              </FormItem>
              <FormItem
                :label="langMap.reportTime[lang]"
                class="leftFlex"
              >
                <Date-picker
                  v-model="times"
                  type="datetimerange"
                  :placeholder="langMap.selectDateAndTime[lang]"
                  format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                />
              </FormItem>
              <Button
                type="info"
                style="margin-left:20px;"
                @click="searchData1"
              >{{langMap.search[lang]}}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table
        :height="height"
        v-if="dataType == '1'"
        :loading="tableLoading2"
        border
        :columns="col1"
        :data="dataList"
      ></Table>
      <Table
        :height="height"
        v-if="dataType == '2'"
        :loading="tableLoading2"
        border
        :columns="col2"
        :data="dataList"
      ></Table>
      <Table
        :height="height"
        v-if="dataType == '3'"
        :loading="tableLoading2"
        border
        :columns="col3"
        :data="dataList"
      ></Table>
      <Table
        :height="height"
        v-if="dataType == '4'"
        :loading="tableLoading2"
        border
        :columns="col4"
        :data="dataList"
      ></Table>

      <div
        style="text-align:center;padding-top:10px;"
        v-if="dataList.length>0"
      >
        <Page
          :current="dataIndex"
          :total="dataTotal"
          :page-size="15"
          @on-change="goPageData1"
        ></Page>
      </div>
    </Card>
  </div>
</template>

<script>
import api from "../../../api/index.js";
import * as timeUtil from "@/utils/dateTimeUtil.js";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 355,
      dataIndex: 1,
      dataList: [],
      dataTotal: 0,
      tableLoading2: false,
      times: [],
      dataType: "1",
      robotId: 0,
      title: "",
      robotList: [],
      //表格
      tableLoading: false,
      code: "",
      name: "",
      type: "",
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    col1() {
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.reportTime[this.lang],
          width: 150,
          key: "timestamp",
          render(h, params) {
            return h("span", timeUtil.formatTime(params.row.timestamp));
          }
        },
        {
          title: langMap.systemVersion[this.lang],
          key: "softwareVersion"
        }
      ]
    },
    col2() {
      return [
        {
          title: "#",
          width: 100,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.reportTime[this.lang],
          key: "timestamp",
          render(h, params) {
            return h("span", timeUtil.formatTime(params.row.timestamp));
          }
        },
        {
          title: langMap.nominalPower[this.lang],
          key: "powerNominalCapacity"
        },
        {
          title: langMap.remainingPower[this.lang],
          key: "stateOfCharge"
        },
        // {
        //   title: langMap.controlMode[this.lang],
        //   key: "controlMode",
        //   render: (h, { row }) => {
        //     let text = row.controlMode;
            
        //     if (row.controlMode === "1") {
        //       text = langMap.remoteControl[this.lang];
        //     } else if (row.controlMode === "2") {
        //       text = langMap.programControl[this.lang];
        //     }
            
        //     return h("span", text);
        //   }
        // }
      ]
    },
    col3() {
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.reportTime[this.lang],
          width: 150,
          key: "timestamp",
          render(h, params) {
            return h("span", timeUtil.formatTime(params.row.timestamp));
          }
        },
        {
          title: langMap.coordinateType[this.lang],
          width: 130,
          key: "flag",
          render: (h, params) => {
            return h("span", (params.row.flag == 1 ? langMap.polarCoordinate[this.lang] : langMap.latLng[this.lang]));
          }
        },
        {
          title: langMap.longitudeAngle[this.lang],
          key: "var1"
        },
        {
          title: langMap.latitudeDistance[this.lang],
          key: "var2"
        },
        {
          title: langMap.gpsTime[this.lang],
          key: "gpsdatetime",
          render(h, params) {
            return h("span", timeUtil.formatTime(params.row.gpsdatetime));
          }
        },
        {
          title: langMap.directionInfo[this.lang],
          key: "direction",
          render(h, params) {
            return h("span", params.row.direction ? Number(params.row.direction.toFixed(1)) : 0);
          }
        },
        {
          title: langMap.speed[this.lang],
          key: "speed",
          width: 110,
        }
      ]
    },
    col4() {
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.reportTime[this.lang],
          key: "timestamp",
          render(h, params) {
            return h("span", timeUtil.formatTime(params.row.timestamp));
          }
        },
        {
          title: langMap.warningLevel[this.lang],
          key: "type",
          render(h, params) {
            return h("span", params.row.type == 1 ? langMap.firstLevelWarning[this.lang] : langMap.secondLevelWarning[this.lang]);
          }
        },
        {
          title: langMap.warningColor[this.lang],
          key: "type",
          render(h, params) {
            return h("span", params.row.type == 1 ? langMap.red[this.lang] : langMap.yellow[this.lang]);
          }
        },
        {
          title: langMap.warningName[this.lang],
          key: "msg"
        }
      ]
    }
  },
  methods: {
    //获取列表
    getList() {
      this.tableLoading = true;
      api.getData("robot-server/robot/list/all", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.robotList = res.data;
          if (this.robotList.length > 0) {
            this.robotId = this.robotList[0].id;
            this.getDataList();
          }
        }
        this.tableLoading = false;
      });
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //搜索数据
    searchData1() {
      this.dataIndex = 1;
      this.getDataList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    },
    goPageData1(index) {
      this.dataIndex = index;
      this.getDataList();
    },
    modelShow() {
      this.dataIndex = 1;
      //this.robotId = '';
      this.dataList = [];
      this.dataTotal = 0;
      this.getDataList();
    },
    getDataList() {
      if (!this.robotId) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.pleaseSelectRobot[this.lang]
        });
      }
      this.dataList = [];
      this.dataTotal = 0;
      let stat = "";
      let end = "";
      if (this.times.length == 2) {
        if (this.times[0]) {
          stat = timeUtil.formatTime(this.times[0]);
        }
        if (this.times[1]) {
          end = timeUtil.formatTime(this.times[1]);
        }
      }
      this.tableLoading2 = true;
      api
        .getData(
          "notice-server/data/history/" +
            this.robotId +
            "/" +
            this.dataType +
            "?start=" +
            stat +
            "&end=" +
            end +
            "&index=" +
            this.dataIndex,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.dataList = res.data.rows;
            this.dataTotal = res.data.total;
          }
          this.tableLoading2 = false;
        });
    }
  },
  created() {
    // Set default time to current day (00:00:00 to 23:59:59)
    const today = new Date();
    const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
    const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
    this.times = [startOfDay, endOfDay];
    
    this.getList();
  }
};
</script>

<style>
</style>
